import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth-service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class SidebarComponent implements OnInit {
  @Input() collapsed = false;
  @Input() mobileOpen = false;
  @Output() closeMenu = new EventEmitter<void>();
  // desktop collapse / expand button at the top of the menu
  @Output() toggleCollapse = new EventEmitter<void>();
  private router = inject(Router);
  private authService = inject(AuthService);
  userData: any = {};
  roId: number = 0;


  ngOnInit() {
    // You can add any initialization logic here if needed
    this.userData = JSON.parse(localStorage.getItem('user_details') || '{}');
    this.roId = Number(this.userData?.user?.roleId || 0);

  console.log('Role ID:', this.roId);
  }

  onResourcesMenuClick() {
    sessionStorage.setItem('resourcesNavSource', 'direct');
    localStorage.removeItem('resourceData');
  }
   


  // lo
  logout() {
    const session = JSON.parse(localStorage.getItem('user_details') || '{}');

    const payload = {
      userId: session?.user?.id || 0,
      refreshToken: session?.tokens?.refreshToken || ''
    };
    this.authService.UserLogout(payload).subscribe({
      next: () => {
        localStorage.removeItem('user_details');
        this.router.navigate(['/login']);
      },
      error: (error) => {
        console.error('Logout failed:', error);
      }
    });
  }
}
